<template>
  <div>
    <ContentHeader title="Add Robot" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()">
                <div class="card-body">
                  <div class="form-group">
                    <label for="name">Robot Name</label>
                    <input type="text" class="form-control" :class="{ 'border-danger': $v.payload.name.$error }"
                      id="name" placeholder="Enter name" v-model="payload.name" />

                    <div class="text-danger" v-if="$v.payload.name.$error">
                      <small>{{ $v.payload.name.required ? `Maximum length is
                        ${$v.payload.name.$params.maxLength.max} characters` :
                        'Robot Name is Required' }}</small>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-group mb-0">
                      <label for="image">Image</label>
                      <div class="row">
                        <div class="col-md-7">
                          <small class="text-secondary">*Preview</small>
                          <div class="image-group">
                            <label @click="resetimage" for="image" class="image-upload-label rounded">
                              <i class="fas fa-edit"></i>
                            </label>
                            <img :src="preview_image" class="rounded preview-image" :class="{
                              'image-exist': img,
                              'border border-danger':
                                image_validation_message ||
                                $v.payload.image.$error,
                            }" />
                          </div>
                        </div>
                      </div>
                      <input type="file" class="d-none" id="image" placeholder="Enter Image"
                        @change="handleImageUpload($event)" accept="image/png, image/jpeg" />
                    </div>
                    <div class="text-danger" v-if="image_validation_message">
                      <small>{{ image_validation_message }}</small>
                    </div>
                    <div class="text-danger" v-if="$v.payload.image.$error">
                      <small>Image Required</small>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="strategy">Strategy</label>
                    <vue-editor id="editorStrategy" v-model="payload.strategy"></vue-editor>
                    <!-- <textarea
                      class="form-control"
                      :class="{
                        'border-danger': $v.payload.strategy.$error,
                      }"
                      id="strategy"
                      placeholder="Enter Strategy"
                      v-model="payload.strategy"
                      rows="4"
                    ></textarea> -->

                    <div class="text-danger" v-if="$v.payload.strategy.$error">
                      <small>Strategy Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="description">Description</label>
                    <vue-editor id="editorDescription" v-model="payload.description"></vue-editor>
                    <!-- <textarea
                      class="form-control"
                      :class="{
                        'border-danger': $v.payload.description.$error,
                      }"
                      id="description"
                      placeholder="Enter description"
                      v-model="payload.description"
                      rows="4"
                    ></textarea> -->

                    <div class="text-danger" v-if="$v.payload.description.$error">
                      <small>Description Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="robot_type">Robot Type</label>
                    <input type="text" class="form-control" :class="{ 'border-danger': $v.payload.robot_type.$error }"
                      id="robot_type" placeholder="Enter robot type" v-model="payload.robot_type" />
                    <small class="text-secondary">*Example : Forex, Gold, Crypto, Index,etc.</small>
                    <div class="text-danger" v-if="$v.payload.robot_type.$error">
                      <small>{{ $v.payload.robot_type.required ?
                        'Robot Type is Required' : '' }}</small>
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <label for="pairOption">Risk Level</label>
                    <multiselect v-model="payload.risk_level" 
                    :class="{'border-danger': $v.payload.risk_level.$error }"
                      :options="risk_level.map(risk => risk.level)">
                    </multiselect>
                    <div class="text-danger" v-if="$v.payload.risk_level.$error">
                      <small>Risk Level Required</small>
                    </div>
                  </div> -->
                  <div class="form-group">
                    <label for="fileInput">Trade Report File</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="fileInput" @change="handleFileUpload($event)"
                          accept=".jpg,.jpeg,.pdf,.mq5" />
                        <label class="custom-file-label" for="fileInput"
                          :class="{ 'border-danger': trp_validation_message }">{{
                            trade_report_label }}</label>
                      </div>
                    </div>
                    <small class="text-secondary">*Format file .jpg,.jpeg,.pdf,.mq5 and file size maximum
                      2mb.</small>
                    <div class="text-danger" v-if="trp_validation_message || trp_validation_message !== ''">
                      <small>{{ trp_validation_message ?? "" }}</small>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="form-group">
                      <label for="basic_price">Basic Price(Rp)</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic_price">Rp.</span>
                        </div>
                        <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          class="form-control" :class="{ 'border-danger': $v.payload.basic_price.$error }"
                          @input="formatNumber" @keyup="formatOnBlur" @blur="formatOnBlur" id="basic_price" min="0"
                          placeholder="Enter Basic Price" v-model="payload.basic_price" />
                      </div>
                      <div class="text-danger" v-if="$v.payload.basic_price.$error">
                        <small>Basic Price Required</small>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-group">
                      <label for="trade_report_url">Trade Report Url</label>
                      <input type="text" class="form-control"
                        :class="{ 'border-danger': $v.payload.trade_report_url.$error }" id="trade_report_url"
                        placeholder="Enter Trade Report Url" v-model="payload.trade_report_url" />
                      <div class="text-danger" v-if="$v.payload.trade_report_url.$error">
                        <small>Trade Report Url Required</small>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-group">
                      <label for="trade_report_url">Installation video Url (Youtube)</label>
                      <input type="text" class="form-control"
                        :class="{ 'border-danger': $v.payload.installation_video_url.$error }"
                        id="installation_video_url" placeholder="Enter installation video url"
                        v-model="payload.installation_video_url" />
                      <div class="text-danger" v-if="$v.payload.installation_video_url.$error">
                        <small>Installation video is required</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <router-link class="btn btn-outline-danger mr-3" :to="{ name: 'RobotList' }">
                    Back
                  </router-link>
                  <button type="submit" href="#"
                    class="btn btn-success btn-block d-flex align-items-center justify-content-center"
                    :disabled="submitStatus === 'PENDING'">
                    <div v-if="loading" class="spinner-border text-light me-2" role="status"></div>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="crop-modal" ref="crop-modal" centered title="BootstrapVue" hide-footer hide-header>
      <cropper :class="{
        'image-exist': img,
        'border-danger': image_validation_message || $v.payload.image.$error,
      }" class="cropper rounded image-cropper-style" :src="img" :autoZoom="false" :stencil-props="{
        aspectRatio: 1 / 1,
      }" ref="cropper" />
      <div class="py-3 row">
        <div class="col-6">
          <button class="btn btn-outline-danger w-100" @click="hideModal('crop-modal')">
            Close
          </button>
        </div>
        <div class="col-6">
          <button class="btn btn-success w-100" @click="getImageCropped()">
            Ok
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from "../../services/ApiServices";
import isFileAllowed from "../../helpers/tradeReportHelper"
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, maxLength } from "vuelidate/lib/validators";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { VueEditor } from "vue2-editor";
import Vue from 'vue';

export default {
  data() {
    return {
      payload: {
        vendor_id: "",
        name: "",
        strategy: "",
        description: "",
        robot_type: "",
        lot_size: "",
        active_pair: "",
        pair_option: "",
        basic_price: "",
        image: "",
        trade_report_file: "",
        trade_report_url: "",
        installation_video_url: "",
      },
      BASIC_PRICE: "",
      preview_image: null,
      img: null,
      image_validation_message: null,
      trp_validation_message: null,
      trade_report_label: "Choose File",
      submitStatus: null,
      errorMessage: null,
      loading: false,
      pair_options: [
        'Forex Major',
        'Forex Minor',
        'Forex Exotic',
        'Index',
        'Stock',
        'Comodity'
      ],
      errors: null,
    };
  },
  validations: {
    payload: {
      name: {
        required,
        maxLength: maxLength(16),
      },
      trade_report_url: {
        required,
      },
      installation_video_url: {
        required,
      },
      strategy: {
        required,
      },
      description: {
        required,
      },
      robot_type: {
        required
      },
      basic_price: {
        required,
      },
      image: {
        required,
      },
      trade_report_file: {
        required,
      },
    },
  },
  components: {
    ContentHeader,
    Cropper,
    VueEditor
  },
  watch: {
    'trp_validation_message': function () {
      //console.log(newVal);
      //to work with changes in someOtherProp
    },
  },
  methods: {
    formatNumber() {
      let plainNumber = this.payload.basic_price.replace(/,/g, '');
      if (!isNaN(plainNumber) && plainNumber.length > 0) {
        this.inputValue = Number(plainNumber).toLocaleString('en-US');
      } else if (plainNumber.length === 0) {
        this.payload.basic_price = '';
      } else {
        this.payload.basic_price = this.payload.basic_price.slice(0, -1);
      }
    },
    formatOnBlur() {
      if (this.payload.basic_price) {
        this.payload.basic_price = Number(this.payload.basic_price.replace(/,/g, '')).toLocaleString('en-US');
      }
    },
    removeFormat() {
      this.payload.basic_price = this.payload.basic_price.replace(/,/g, '');
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    resetimage() {
      document.getElementById('image').value = null
    },
    handleImageUpload(event) {
      if (event.target.value == "") {
        this.preview_image = "";
      }
      let file = event.target.files[0];
      if (!file) {
        this.image_validation_message = null;
        this.img = null;
        this.payload.image = "";
      } else {
        if (file.size <= 1024 * 1024 * 2) {
          if (
            file["type"] === "image/jpeg" ||
            file["type"] === "image/jpg" ||
            file["type"] === "image/png"
          ) {
            this.showModal("crop-modal");
            this.image_validation_message = null;
            this.img = URL.createObjectURL(event.target.files[0]);
          } else {
            this.image_validation_message =
              "This Field must be an image (.jpg, .jpeg, .png)";
            this.img = null;
          }
        } else {
          this.image_validation_message = "Image must be less than 2MB";
          this.img = null;
        }
      }
    },

    getImageCropped() {
      const { canvas } = this.$refs.cropper.getResult();

      this.payload.image = this.dataURLtoFile(
        canvas.toDataURL(),
        `${Date.now()}.jpg`
      );
      this.preview_image = URL.createObjectURL(this.payload.image);
      this.hideModal("crop-modal");
    },

    handleFileUpload(event) {
      let file = event.target.files[0];

      if (!file) {
        this.trade_report_label = "Choose File";
      } else {
        console.log("File size must be less than 2MB", file.size);
        if (file.size > 2000000) {
          this.trp_validation_message = "File size must be less than 2MB";
          this.payload.trade_report_file = file;
          this.trade_report_label = file.name;
        } else {
          if (isFileAllowed(file.name)) {
            console.log("Masuk!! you are allowed!");
            this.trp_validation_message = null;
            this.payload.trade_report_file = event.target.files[0];
            this.trade_report_label = event.target.files[0].name;
          } else {
            this.trp_validation_message =
              "This Field must be file with format of .jpg, .jpeg, .pdf or .mq5";
            this.payload.trade_report_file = null;
            this.trade_report_label = "Choose File";
          }
        }
      }
    },

    async handleCreateData() {
      // this.removeFormat()
      this.BASIC_PRICE = this.payload.basic_price.replace(/,/g, '');
      console.log("BASIC PRICE : ", this.BASIC_PRICE);
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.handleInvalidField();
        this.loading = false
      } else {
        if (this.payload.trade_report_file.size <= 2000000) {
          Vue.swal.fire({
            title: "Are you sure want to submit?",
            text: "You can change it anytime!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#000000",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then(async (res) => {
            if (res.isConfirmed) {
              this.submitStatus = "PENDING";
              this.loading = true
              let data = new FormData();

              let strategy = this.payload.strategy.replace(/<\/?p>/g, '');
              let description = this.payload.description.replace(/<\/?p>/g, '');

              data.append("vendor_id", this.$store.getters.user.id);
              data.append("name", this.payload.name);
              data.append("basic_price", this.BASIC_PRICE);
              data.append("image", this.payload.image);
              data.append("strategy", strategy);
              data.append("description", description);
              data.append("type", this.payload.robot_type);
              data.append("trade_report_file", this.payload.trade_report_file);
              data.append("trade_report_url", this.payload.trade_report_url);
              data.append("installation_video_url", this.payload.installation_video_url);

              try {
                // Send POST request with data
                const response = await apiClient.post("/", data);

                // Assuming the API response contains the new robot's ID
                const newRobotId = response.data.data.id;
                this.submitStatus = "OK";
                this.loading = false
                this.errors = null;
                Vue.swal.fire({
                  icon: "success",
                  title: "Your work has been saved",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(
                  () => {
                    this.$router.push({ name: "RobotDetails", params: { id: newRobotId } });
                  }
                );
              } catch (error) {
                this.submitStatus = "ERROR";
                this.loading = false;
                // console.log("Error : ", error.data.data.trade_report_file);

                // Check for status code 500
                if (error.status == 500) {
                  Vue.swal.fire({
                    icon: "error",
                    title: "Oops... Invalid on Name field! ",
                    text: `Server Error!", "Something went wrong on the server. Please try again later.`,
                    showConfirmButton: true,
                    confirmButtonColor: "#000000",
                  });
                }
                else if (error.status == 400) {
                  if (error.data.data.name) {
                    // this.errors.name = error.data.data.name;
                    console.log("ERROR NAME : ", error.data.data.name);
                    Vue.swal.fire({
                      icon: "error",
                      title: "Oops... Invalid on Name field! ",
                      text: `${error.data.data.name ? error.data.data.name : `Gambar` + error.data.data.image[0]}`,
                      showConfirmButton: true,
                      confirmButtonColor: "#000000",
                    });
                  }
                  if (error.data.data.trade_report_file) {
                    this.trp_validation_message = error.data.data.trade_report_file[0]
                  }
                }
              }
            } else {
              console.log("DICANCEL!");
              this.submitStatus = null;
              this.loading = false
              this.formatNumber()
              this.formatOnBlur()
              this.errors = null;
            }
          })
        }

      }
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    handleInvalidField() {
      let invalidFields = [];
      // Define a mapping of validation fields to their display names
      const fieldNames = {
        name: "Name",
        image: "Image",
        strategy: "Strategy",
        description: "Description",
        robot_type: "Robot Type",
        trade_report_file: "Trade Report File",
        basic_price: "Basic Price",
        trade_report_url: "Trade Report URL",
        installation_video_url: "Installation Video URL",
      };

      // Iterate through the validations
      for (let field in this.$v.payload) {
        if (this.$v.payload[field].$invalid) {
          invalidFields.push(fieldNames[field]);
        }
      }
      // Construct the alert message
      let alertMessage = `Please fill out the following : \n ${invalidFields.join(", ")}`;

      // Show the alert with the invalid fields
      Vue.swal({
        icon: "error",
        title: "Oops...",
        text: alertMessage,
      });
    },
  },
};
</script>
